<template>
  <div class="bill-list">
    <CommonList
      ref="commonList"
      type="receipt"
      style="padding-bottom: 50px; overflow: auto"
      :selectTypeFilter="selectTypeFilter"
      @edit="onEdit"
    />
    <LayoutFooter />
  </div>
</template>

<script>
import CommonList from "@components/CommonList.vue";
import LayoutFooter from "@components/LayoutFooter.vue";

export default {
  name: "BillList",

  components: {
    CommonList,
    LayoutFooter,
  },

  data() {
    return {
      dataList: [],
      selectTypeFilter: "receipt",
    };
  },

  methods: {
    onEdit(id) {
      this.$router.push({
        name: "billDetail",
        query: {
          id: id,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.bill-list {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
